export default {
  satelliteReport: {
    satelliteReport: "Rapports satellites",
    generateReport: "Générer un nouveau rapport",
    satelliteReportTooltip:
      "Ici, vous pouvez obtenir 5 rapports satellites de base pour vos fermes (NDVI, MSAVI, NDRE, RECI, LSWI) afin d'évaluer la santé des cultures en fonction des niveaux de nutriments et d'humidité",
    operatorName: "Nom de l'opérateur",
    issueDate: "Date d'émission",
    selectFarm: "Sélectionner une ferme",
    chooseFarm: "Choisir une ferme",
    chooseZone: "Choisir une zone",
    genReport: "Générer un rapport",
    viewReport: "Voir le rapport",
    farmName: "Nom de la ferme",
    allFarms: "Toutes les fermes",
    zone: "Zone(s)",
    selectReportType: "Sélectionner le type de rapport",
    report: "Rapport",
    cropHealth: "Santé des cultures (NDVI)",
    doi: "Date d'intérêt",
    dateOfImage: "Date de l'image avec faible couverture nuageuse",
    reciValues: "Valeurs RECI comprises entre 0 et 10",
    ndviValues: "Valeurs NDVI",
    rangeSubtitle: "Les valeurs proches de 1 indiquent une végétation en meilleure santé"
  },

      
      deforestation: {
        issueFound: "Problème trouvé",
        attachFiles: "Joindre des fichiers",
        attachFile: "Joindre un fichier",
        addNewSupplier: "Ajouter un nouveau fournisseur",
        regionalRiskAssessment: "Évaluation régionale des risques",
        name: "Nom",
        email: "E-mail",
        phoneNumber: "Numéro de téléphone",
        pays:  "Paye",
        producerData:{
          addProducers:"Ajouter un nouveau producteur",
          countryInfo: "Champ pour saisir ou afficher le pays associé à un producteur."
      },
      oneForAllFarms:"Un pour toutes les fermes",
      oneForEachFarm: "Un pour chaque ferme",
      selectFileToUpload: "Sélectionner un fichier pour télécharger les données",
      uploadExistingAssessment:"Télécharger une évaluation existante",
      completeDimitraAssessment:"Évaluation par opérateur ou fournisseur",
      assessmentByFarmer:"Évaluation par l'agriculteur",
      uploadedToEU: "Téléchargé sur le portail de l'UE",
      pending: "En attente",
      underReview: "En cours d'examen",
      compliant: "Conforme",
      nonCompliant: "Non conforme",
      analyzeDeforestation: "Analyse de la déforestation",
      readyToProceed: "Prêt à continuer",
      processingFarm: "Traitement de la ferme",
      mitigationRequired: "Atténuation requise",
      
      selectCountry: "Sélectionner un pays",
      internalReferenceNumberMustBeAlphanumeric :"Le numéro de référence interne doit être alphanumérique",
      atLeastOneOfSupplierIdOrSupplierNameIsRequired: "Au moins un ID fournisseur ou un nom de fournisseur est requis",
      atLeastOneOfOperatorIdOrOperatorNameIsRequired: "Au moins un ID opérateur ou un nom d'opérateur est requis",
      netMassIsRequired: "La masse nette est requise",
      netMassMustBeValid: "La masse nette doit être valide",
      thisFieldIsRequired: "Ce champ est requis",
      volumeMustBeNumeric: "Le volume doit être numérique",
      nameIsRequired: "Le nom est requis",
      firstNameIsRequired: "Le prénom est requis",
      lastNameIsRequired: "Le nom de famille est requis",
      countryIsRequired:"Le pays est requis.",
      
      confirmPdfDownload: "Voulez-vous télécharger tous les fichiers attachés au format PDF ?",
      confirmJsonDownload: "Voulez-vous télécharger tous les fichiers attachés au format JSON ?",
      basicFinalFarmListWithStatus: "Liste finale de base des fermes avec statut",
      detailedInformationIncludingDescriptionOfRiskMitigationActivities: "Informations détaillées incluant la description des activités de réduction des risques",
      completeDocumentIncludingRiskMitigationAndAttachedDocuments: "Document complet incluant la réduction des risques et les documents attachés",
      
      existing: "Existant",
      survey: "Enquête",
      
      operatorInformation: "Informations sur l'opérateur",
      addNewOperator: "Ajouter un nouvel opérateur",
      
      reportAddedSuccessfully: "Rapport ajouté avec succès",
      reportUpdatedSuccessfully: "Rapport mis à jour avec succès",
      itemDeletedSuccessfully : "Élément supprimé avec succès.",
      reportDeletedSuccessfully: "Rapport supprimé avec succès",
      anErrorOccurredWhileDeletingTheReport: "Une erreur est survenue lors de la suppression du rapport",
      
      valueMustBeBetween02And4 : "La valeur doit être comprise entre 0,2 et 4",
      
      complianceRiskWarnings: "Avertissements sur les risques de conformité",
      complianceRiskWarningsInfo: "Affiche le titre de la section, indiquant que cette zone se concentre sur les avertissements liés aux risques de conformité dans le processus de diligence raisonnable.",
      netMassKg: "Masse nette (kg)",
      volumeM3: "Volume (m3)",
      warning: "Avertissement",
      complete: "Complet",
      undoDelete: "Annuler la suppression",
      
      verifyingLocationsData: "Vérification des données des lieux...",
      crossCheckingWithProductionPlaces: "Vérification croisée avec les lieux de production...",
      almostTherePleaseHoldOn : "Presque terminé, veuillez patienter...",
      LocationVerifiedSuccessfully:"Emplacement(s) vérifié(s) avec succès !",
      allProductionPlacesAndLocationsHaveBeenConfirmed : "Tous les lieux de production et emplacements ont été confirmés !",
      errorCheckingOverlaps: "Erreur lors de la vérification des chevauchements.",
      farmIsBiggerThan4HectaresItNeedsToBeAPolygon: "La ferme fait plus de 4 hectares, elle doit être un polygone",
      failedToFetchSettings: "Impossible de récupérer les paramètres. Veuillez vérifier vos paramètres ou contacter le support si le problème persiste.",
      farmCountryNotDefined: "Le pays de la ferme n'est pas défini.",
      theGeofencesSupposeToBeIn: "La géofence est censée être dans",
      butItsIn: "mais elle est dans",
      geofenceIsInOcean: "La géofence ou une partie de la géofence est dans l'océan.", 
      
      existingReport: "Rapport de déforestation existant",
      dimitraReport: "Rapport de déforestation Dimitra",
      
      anErrorOccuredWhileFetchingTheDeforestationReport: "Une erreur s'est produite lors de la récupération du rapport de déforestation.",
      
      veryHighDeforestationProbability: "Probabilité de déforestation très élevée",
      highDeforestationProbability: "Probabilité de déforestation élevée",
      mediumDeforestationProbability: "Probabilité de déforestation moyenne",
      lowDeforestationProbability: "Probabilité de déforestation faible",
      veryLowDeforestationProbability: "Probabilité de déforestation très faible",
      zeroNegligibleDeforestationProbability: "Probabilité de déforestation nulle/négligeable",
      manuallyMitigated: "Atténué manuellement",
      
      "Zero/Negligible Deforestation Probability":"Probabilité de déforestation nulle/négligeable",
      "Zero Deforestation Probability": "Probabilité de déforestation nulle",
      "Low Deforestation Probability": "Probabilité de déforestation faible",
      "High Deforestation Probability": "Probabilité de déforestation élevée",
      "Very Low Deforestation Probability": "Probabilité de déforestation très faible",
      "Medium Deforestation Probability": "Probabilité de déforestation moyenne",
      "Very High Deforestation Probability":"Probabilité de déforestation très élevée",
      
      disputeReason: "Raison du différend",
      disputeStatus: "Statut du différend",
      farmRegId: "ID d'enregistrement de la ferme",
      productionPlaceId: "ID du lieu de production",
      disputeId: "ID du différend",
      disputeArea: "Taille de la zone",
      disputeResolution: "Résolution du différend",
      deforestationComplianceReport: "Rapports de conformité à la déforestation",
      noDeforestationComplianceReport: "Aucun rapport de conformité à la déforestation trouvé",
      loadingDeforestationComplianceReport:
        "Chargement du rapport de conformité à la déforestation",
      farmName: "Nom de la ferme",
      farmRegistrationId: "ID d'enregistrement de la ferme",
      farmerName: "Nom de l'agriculteur",
      farmerRegistrationId: "ID d'enregistrement de l'agriculteur",
      uniqueFarmerId: "ID unique de l'agriculteur",
      uniqueFarmId: "ID unique de la ferme",
      farmLocation: "Emplacement de la ferme",
      area: "Surface",
      farmAddress: "Adresse de la ferme",
      dateOfRequest: "Date de la demande",
      status: "Statut",
      settings: "Paramètres",
      selectDefaultMeasurementUnit: "Sélectionnez les unités de mesure par défaut",
      selectDefaultMeasurementUnitInfo: "Permet la sélection des unités de mesure par défaut, y compris la spécification de l'unité, la définition d'une limite maximale et le marquage en tant qu'option par défaut.",
      maxLimit: "Limite maximale",
      maxLimitInfo: "Définit la valeur ou le seuil maximum autorisé pour un paramètre particulier.",
      asDefault: "Définir comme par défaut",
      productMass: "Masse du produit",
      productMassUnitInfo: "Spécifie l'unité pour mesurer la masse d'un produit.",
      volumeUnitInfo: "Spécifie l'unité pour mesurer le volume d'un produit.",
      operatorInfo: "Fait référence à une personne ou entité responsable de la gestion ou du fonctionnement d'un système ou d'un processus.",
      supplierInfo: "Une entité qui fournit des biens ou des services à une autre entité.",
               supplierInformation: "Informations sur le fournisseur",
      userTypeInfo: "Classe les individus ou les entités en fonction de leur rôle ou de leurs permissions dans le système.",
      unit: "Unité",
      userType: "Type d'utilisateur",
      eudrPortalApiKeys: "Clés API du portail EUDR",
      apiKey: "Clé API",
      apiSecret: "Clé secrète API",
      headingCreatedSuccessfully: "Titre créé avec succès",
      headingOrderSuccessfullyUpdated: "Ordre du titre mis à jour avec succès",
      headingUpdatedSuccessfully: "Titre mis à jour avec succès",
      questionTypeNotDefined: "Type de question non défini",
      assessmentRiskMitigationLvl: "Niveaux de mitigation des risques d'évaluation",
      assessmentRiskMitigationLvlInfo: "Catégorise la gravité des risques liés à l'utilisation des terres, aux pratiques forestières et à l'expansion agricole. Ces niveaux aident à identifier l'impact potentiel des activités sur les zones forestières et guident les actions appropriées pour atténuer les conséquences négatives. Catégorise les niveaux de stratégies de mitigation des risques, y compris très élevé, élevé, moyen, faible et zéro/négligeable.",
      dynamicExpiryTime: "Période d'expiration dynamique",
      dynamicExpiryTimeInfo: "Définit une période après laquelle certaines données ou paramètres expirent automatiquement. Configure les paramètres liés aux rapports de déforestation, y compris les options de renouvellement automatique.",
      eudrDeforestationAssessment: "Évaluation de la déforestation EUDR",
      autoRenewalIf: "Renouvellement automatique lorsque ajouté au rapport de diligence raisonnable",
      declarationStatements: "Déclarations",
      declarationStatementsInfo: "Déclarations faites par la partie responsable certifiant l'exactitude, l'exhaustivité et l'authenticité des informations contenues dans le rapport.",
      filterDeclaration: "Filtrer les déclarations",
      declarationTitle: "Titre de la déclaration",
      declarationTitleInfo: "Titre ou en-tête d'une déclaration, fournissant un contexte ou résumant son contenu.",
      applicableCountry: "Pays concernés",
      applicableCountryInfo: "Liste les pays auxquels certains paramètres ou réglementations s'appliquent.",
      addMore: "Ajouter plus",
      autoRenewal: "Renouvellement automatique",
      createNewAssessment: "Créer une nouvelle évaluation",
      userDimitraAssessment: "Utiliser les évaluations Dimitra",
      shipmentList: "Liste des expéditions",
      generalData: "Données générales",
      check: "Vérifier",
      eudrComplianceStatus: "Statut de conformité EUDR",
      farmLatitude: "Latitude de la ferme",
      farmLongitude: "Longitude de la ferme",
      shareQRCode: "Partager le code QR",
      copy: "Copier",
      allCountries: "Tous les pays",
      allRegions: "Toutes les régions",
      allFarms: "Toutes les fermes",
      allProducer: "Tous les producteurs",
      viewCertificate: "Voir le certificat",
      assignmentIssued: "Mission émise",
      complianceCertification: "Certification de conformité",
      noComplianceCertification: "Aucune certification de conformité trouvée",
      loadingComplianceCertification: "Chargement de la certification de conformité",
      eudrForestAssessment: "Évaluations forestières EUDR",
      assessmentReport: "Rapport d'évaluation",
      downloadPDF: "Télécharger le PDF",
      back: "Retour",
      farmDetails: "Détails de la ferme",
      dimitraFarmId: "Identifiant de la ferme Dimitra",
      dimitraFermerId: "Identifiant de l'agriculteur Dimitra",
      totalGeofenceAreaHA: "Superficie totale de la géofence (AC)",
      forestLossHA: "Perte forestière (AC)",
      forestGainHA: "Gain forestier (AC)",
      forestUnchangedHA: "Forêt inchangée (AC)",
      shareCertificate: "Partager le certificat",
      forestUnchanged: "Forêt inchangée",
      forestLoss: "Perte forestière",
      forestGain: "Gain forestier",
      totalGeofenceArea: "Superficie totale de la géofence",
      deforestationProbability: "Probabilité de déforestation",
      colorCode: "Code couleur",
      geofenceArea: "Zone géofencé",
      percentageOfGeofenceArea: "Pourcentage de la zone géofencé",
      view: "Voir",
      customization: "Personnalisation",
      recordsPerpage: "Enregistrements par page",
      restoreDefault: "Restaurer par défaut",
      apply: "Appliquer",
      forestAssessmentHelp: "Si vous avez des questions sur ce rapport ou besoin d'aide pour le comprendre, contactez-nous via le service d'assistance.",
      overallDeforestationProbability: "Probabilité globale de déforestation",
      zeroOrNeglegible: "Zéro ou négligeable",
      very_high: "Très élevé",
      medium: "Moyen",
      high: "Élevé",
      allStatus: "Tous les statuts",
      low: "Faible",
      very_low: "Très faible",
      assessmentIssued: "Évaluation émise",
      certificateIssued: "Certificat émis",
      assessmentNo: "Numéro d'évaluation",
      blockchainCertificateDesc: "L'empreinte de validation du certificat blockchain sera disponible dès l'acceptation du certificat",
      blockchainValidation: "Validation du certificat blockchain",
      openBlockchainPage: "Ouvrir la page Blockchain",
      clickLinkDesc: "Cliquez sur le lien ci-dessus pour valider le certificat sur la blockchain",
      zeroOrNegligible: "Zéro / Négligeable",
      veryHigh: "Très élevé",
      veryLow: "Très faible",
      tooltip: {
      dimitraFarmId: "Identifiant unique associé à une ferme spécifique dans le système Dimitra.",
      farmName: "Nom désigné de la ferme.",
      farmRegistrationId: "Numéro d'enregistrement de la ferme.",
      farmLocation: "Coordonnées géographiques spécifiques ou emplacement de la ferme.",
      dimitraFermerId: "Identifiant distinct lié à un agriculteur dans le système Dimitra.",
      farmerName: "Identification de l'individu responsable de la ferme.",
      farmerRegistrationId: "Numéro d'enregistrement de l'agriculteur.",
      assessmentNo: "Numéro unique attribué à l'évaluation."
      },
      
      enterPhoneNumber: "Entrez le numéro de téléphone",
      whoWillAddPlace: "Qui ajoutera les données du lieu de production?",
      companyId: "ID de l'entreprise",
      activity: "Activité",
      placeOfActivity: "Lieu d'activité",
      countryOfActivity: "Pays d'activité",
      operatorPlaceOfActivity: "Lieu d'Activité de l'Opérateur",
      operatorCountryOfActivity: "Pays d'Activité de l'Opérateur",
      countryOfEntry: "Pays d'entrée",
      productDetail: "Détails du produit",
      subProduct: "Sous-produit",
      productionDescription: "Description du produit",
      netMass: "Masse nette",
      volume: "Volume",
      scietificName: "Nom scientifique",
      commonName: "Nom commun",
      eudrDueDeligenceReports: "Rapports de diligence raisonnable EUDR",
      EUDRAssessmentReport: "Rapport d'évaluation EUDR",
      createNewReport: "Créer un nouveau rapport",
      eudrRefNo: "Référence EUDR",
      eudrRefNoInfo: "Fonctionnalité pour trouver des informations spécifiques liées à l'expédition.",
      statusInfo: "Le statut actuel de l'expédition en rapport avec le rapport de diligence raisonnable.",
      eudrAndInternalRefNo: "Référence interne / EUDR",
      exporterAndSupplier: "Exportateur et Fournisseur",
      internalRefNo: "Numéro de référence interne",
      supplier: "Fournisseur",
      eoriNumber: "Numéro EORI",
      operator: "Opérateur",
      quantity: "Quantité",
      product: "Produit",
      noOfFarms: "Nombre de fermes",
      farmsAndQuantity: "Fermes & Quantité",
      country: "Pays",
      lastUpdated: "Dernière mise à jour",
      dueDeligenceStatus: "Statut de diligence raisonnable",
      edurDueDeligenceStatus: "Statut de diligence raisonnable EUDR",
      reject: "Rejeter",
      discard: "Supprimer",
      saveAndContinueLater: "Enregistrer et continuer plus tard",
      requestAdditionalInformation: "Demander des informations supplémentaires",
      requestAdditionalInformationShort: "Demander plus d'informations",
      uploadToEudr: "Télécharger sur EUDR",
      productionPlaces: "Lieux de production",
      productionPlacesTT: "Emplacements où les biens sont fabriqués ou cultivés.",
      productionPlacesCountryInfo: "Une entité territoriale distincte avec son propre gouvernement et ses frontières.",
      productionPlacesProducersInfo: "Entité responsable de la création ou de la culture des biens.",
      next: "Suivant",
      dueDeligenceReportCreation: "Création de rapport de diligence raisonnable",
      producer: "Producteur",
      "approveMessage": "Êtes-vous sûr de vouloir approuver ce rapport ? En approuvant ce rapport, il sera téléchargé de manière permanente sur la blockchain. Un lien blockchain et un code QR seront générés, et aucune autre mise à jour ou modification ne pourra être effectuée. Souhaitez-vous continuer ?",
      select: "Sélectionner",
      productionPlacesFarmAndFarmId: "Lieu de production (Ferme) & ID de ferme",
      producerName: "Nom du producteur",
      addressOfProduction: "Adresse de production",
      type: "Type",
      geofence: "Géorepérage",
      areaHa: "Surface (ha)",
      editGeofence: "Modifier le géorepérage",
      totals: "Totaux",
      totalsTT: "La section 'Totaux' fournit un résumé des principales métriques quantitatives pour l'ensemble des données ou du rapport...",
      locationVerification: "Vérification de l'emplacement",
      locationVerificationTT: "Fait référence au processus de confirmation et de validation de l'emplacement géographique des sites de production...",
      AnalysisOfDeforestationStatus: "Analyse du statut de déforestation",
      AnalysisOfDeforestationStatusTT: "L'examen de l'état actuel de la déforestation dans une zone spécifiée...",
      EUDRDeforestationStatus: "Statut de déforestation EUDR",
      EUDRDeforestationStatusTT: "Sélection du statut de déforestation. Probabilité élevée de déforestation...",
      removeAllLowRiskFarm: "Supprimer toutes les fermes à faible risque",
      removeAllHighRiskFarm: "Supprimer toutes les fermes à haut risque",
      attachRiskMigrationDocTT: "Indique l'action d'associer un document unique à toutes les fermes identifiées...",
      attachRiskMigrationDoc: "Joindre un document de mitigation des risques pour toutes les fermes à haut risque",
      removedFarms: "Fermes supprimées de la liste",
      generateCertificate: "Générer un certificat",
      viewDisputeHistory: "Voir l'historique des litiges",
      disputeAssessment: "Évaluation des litiges",
      reportDetails: "Détails du rapport",
      productionPlace: "Lieu de production",
      EUDRDeforestationAssessment: "Évaluation de la déforestation EUDR",
      EUDRcountry: "Le pays où se trouve la ferme, lié au produit dans le rapport de diligence raisonnable...",
      riskAssessment: "Évaluation des risques",
      legalInformation: "Informations juridiques",
      finalReport: "Rapport final",
      editGeolocation: "Modifier la géolocalisation",
      producerCountry: "Pays du producteur",
      manuallyAddData: "Ajouter des données manuellement",
      drawGeofence: "Dessiner un géorepérage",
      uploadFile: "Télécharger un fichier",
      typeyourlocation: "Saisissez le nom/adresse de votre emplacement",
      numberOfPoints: "Nombre de points du polygone",
      viewGeolocation: "Voir la géolocalisation",
      geoLocation: "Géolocalisation",
      Point: "Point",
      Polygon: "Polygone",
      selectFileToUploadData: "Sélectionnez un fichier pour télécharger les données",
      loadingProductionPlaces: "Chargement des lieux de production",
      remove: "Supprimer",
      restore: "Restaurer",
      riskMitigation: "Mitigation des risques",
      assessmentRiskMitigation: "Évaluation de la mitigation des risques",
      riskMitigationHistory: "Historique de la mitigation des risques",
      signParticipationSurvey: "Veuillez signer numériquement pour confirmer votre participation à cette enquête.",
      signedBy: "Signé numériquement par:",
      submissionDate: "Date de soumission",
      eudrReferenceNo: "Numéro de référence EUDR",
      internalReferenceNo: "Numéro de référence interne",
      exporter: "Exportateur",
      exporterInfo: "Nom de l'exportateur...",
      importer: "Importateur",
      importerInfo: "Nom de l'importateur...",
      shipmentReferenceNo: "Numéro de référence de l'expédition",
      shipmentReferenceNoInfo: "Identifiant unique pour référencer l'expédition.",
      ownerShipType: "Type de propriété",
      ownerShipTypeInfo: "Le type de propriété associé à l'expédition.",
      buyer: "Acheteur",
      buyerName: "Nom de l'acheteur",
      port_of_origin: "Port d'origine",
      port_of_origin_info: "Le lieu où commence l'expédition.",
      port_of_destination: "Port de destination",
      port_of_destination_info: "Le port de destination prévu pour l'expédition.",
      no_of_stops: "Nombre d'arrêts",
      shipping_line: "Compagnie maritime",
      shipping_line_info: "La compagnie responsable du transport de l'expédition.",
      expected_arrival_date: "Date d'arrivée prévue",
      expected_arrival_date_info: "Date prévue pour l'arrivée de l'expédition à destination.",
      container_id: "ID du conteneur",
      container_id_info: "Identifiant unique du conteneur d'expédition.",
      container_type: "Type de conteneur",
      container_type_info: "Le type ou la catégorie du conteneur d'expédition.",
      container_size: "Taille du conteneur (pi)",
      container_size_info: "Dimensions physiques du conteneur d'expédition.",
      container_capacity: "Capacité du conteneur (tonnes)",
      container_capacity_info: "Charge maximale ou capacité du conteneur.",
      eudr_reference_number: "Numéro de référence EUDR",
      select_default_measurement_units: "Sélectionnez les unités de mesure par défaut",
      radius: "Rayon",
      maximum_limit: "Limite maximale",
      product_mass: "Masse du produit",
      user_type: "Type d'utilisateur",
      eudr_api_keys: "Clés API du portail EUDR",
      api_key: "Clé API",
      api_secret: "Secret API",
      assessment_risk_mitigation_levels: "Niveaux d'évaluation de la mitigation des risques",
      dynamic_expiry_time_period: "Période d'expiration dynamique",
      eudr_deforestation_assessment: "Évaluation de la déforestation EUDR",
      auto_renewal: "Renouvellement automatique",
      auto_renewal_when_added_to_the_due_diligence_report: "Renouvellement automatique lors de l'ajout au rapport de diligence raisonnable",
      declaration_statements: "Déclarations",
      filter_declaration_statements: "Filtrer les déclarations",
      showing_all: "Tout afficher",
      declaration_title: "Titre de la déclaration",
      applicable_countries: "Pays applicables",
      enabled: "Activé",
      disabled: "Désactivé",
      add_more: "Ajouter plus",
      mark_as_default: "Marquer comme par défaut",
      actions: "Actes",
      locationVerificationTab: {
        confirmationTitle: "Confirmation",
        confirmationMessage: "Vous êtes sur le point de modifier les données de géolocalisation de cette ferme...",
      },
      locationModified: {
        headerTitle: "Emplacement modifié",
        bodyText: "Les données d'emplacement de la ferme ont été mises à jour avec succès."
      },
      processingDialog: {
        modalHeader: "Analyse de l'état de la déforestation",
        modalDescription_first: "Analyse de l'état de déforestation EUDR",
        modalDescription_second: "Vos fermes font l'objet d'une analyse automatisée de la déforestation. Vous serez redirigé vers la liste des rapports de diligence raisonnable pour consulter le statut."
      },
      farmList: {
        title: "Liste des fermes EUDR",
        addFarmGeofenceManually: "Ajouter une clôture de ferme manuellement",
        importGeofenceInBulk: "IMPORTER DES CLÔTURES EN MASSE",
        searchPlaceHolder: "Rechercher par nom d'agriculteur",
        generateCertificate: "Générer un certificat",
        requestAssementReport: "Demander un rapport d'évaluation",
        producer: "Producteur",
        farmNameAndId: "Nom et ID de la ferme",
        addressOfProduction: "Adresse de production",
        registrationDate: "Date d'enregistrement",
        eudrDeforestationStatus: "Statut de déforestation EUDR",
        riskAssessmentStatus: "Statut de l'évaluation des risques",
        assessmentTitle: "Titre de l'évaluation",
        assessmentDescription: "Description de l'évaluation",
        submissionDate: "Date de soumission",
        expiryDate: "Date d'expiration",
        assessmentStatus: "Statut de l'évaluation",
        downloadAsKmx: "Télécharger au format KMX",
        downloadAsKml: "Télécharger au format KML",
        downloadAsShp: "Télécharger au format SHP",
        downloadAsCsv: "Télécharger au format CSV",
        downloadAsExcel: "Télécharger au format EXCEL",
        downloadAsPdf: "Télécharger au format PDF",
        downloadAsGeoJson: "Télécharger au format GeoJSON",
        loadingFarms: "Chargement des fermes"
      },
      dueDeligenceReport: "Paramètres publics des rapports de diligence raisonnable",
      allowPublicDownload: "Autoriser le téléchargement public des clôtures de fermes au format GeoJson",
      showDeforestationSummary: "Afficher le résumé du risque de déforestation EUDR par catégorie",
      cancel: "Annuler",
      createShipment: "Créer un envoi",
      download: "Télécharger",
      print: "Imprimer",
      loading: "Chargement...",
      deforestationAssessmentRiskToleranceLevel: "Niveau de tolérance au risque d'évaluation de la déforestation",
      deforestationAssessmentRiskToleranceLevelInfo: "Utilisez cet outil pour configurer le pourcentage de déforestation acceptable pour chaque évaluation dans votre processus d'évaluation des risques. Les fermes ayant un risque inférieur ou égal au seuil défini seront considérées comme adaptées pour rester dans la DDS sans avoir besoin d'une atténuation des risques.",
      tons: "Tonnes",
      failedToDeleteQuestion: "Échec de la suppression de la question",
      questionOrderSuccessfullyUpdated: "Ordre des questions mis à jour avec succès",
      assessmentUpdatedSuccessfully: "Évaluation mise à jour avec succès",
      pleaseWaitCurrentlyUpdatingChecklist: "Veuillez patienter, mise à jour de la liste de contrôle en cours",
      assessmentDetails: "Détails de l'évaluation",
      dontShowWarning: "Ne plus afficher cet avertissement.",
      dateSubmitted: "Date de soumission",
      addAComment: "Ajouter un commentaire",
      changeAssignee: "Changer d'assigné",
      changeStatus: "Changer de statut",
      assignedUser: "Utilisateur assigné",
      selectAssignee: "Sélectionner un assigné",
      reply: "Répondre",
      discussion: "Discussion",
      attachment: "Pièce jointe",
      sizeKb: "Taille (KB)",
      dateAdded: "Date ajoutée",
      shipmentStatus: "Statut de l'envoi",
      viewStops: "Voir les arrêts",
      enRoute: "En cours de route",
      delivered: "Livré",
      failed: "Échoué",
      removeEudrDeforestationStatus: "Supprimer le statut de déforestation EUDR",
      riskAssessmentStatusIsRequired: "Le statut de l'évaluation des risques est requis",
      failedEudrReportDueSetting: "Veuillez vous assurer que les paramètres des propriétés suivantes sont correctement configurés : expiration du rapport, masse nette, volume et rayon"
    },
  dueDiligence: {
       enableRiskWarnings:  "Activer les avertissements de risque",
    comments: "Commentaires",
    commentsRegardingStatement:"commentaires concernant la déclaration",
    countryOfProduction: "Pays de Production",
      countryOfProductionTT: "Pays de Production",
    containerId:"Id de conteneur",
      createWithoutRiskAssessment: {
        title: "Créer DDS sans évaluation des risques",
        message: "Voulez-vous créer un DDS sans ajouter d'évaluation des risques ? Si oui, les règles de vérification des plaintes ignoreront cette étape.",
        confirmBtnText: "Oui",
        cancelBtnText: "Non"
      },
      noAssessmentWarning: "Le rapport DDS manque d'évaluations des risques.",
      disputeReason: "Veuillez choisir une raison de litige.",
      agricultureAgreement: "Veuillez accepter les conditions avant de continuer.",
      attachDisputeFile: "Veuillez joindre un fichier avant de soulever un litige.",

      // Activity Log translations
      activityLog: "Journal d'activité",
      activityLogTT: "Journal des actions effectuées sur ce rapport.",
      user: "Utilisateur",
      userRole: "Rôle de l'utilisateur",
      ipAddress: "Adresse IP",
      segment: "Segment",
      activityDescription: "Description de l'activité",
      producerTT: "Sélection des producteurs ou fabricants impliqués dans la chaîne d'approvisionnement.",
            supplierInformation: "Informations sur le fournisseur",
      supplierInformationTT: "Détails sur l'entité fournissant des biens ou services.",
      operatorTooltip: "Sélectionnez l'opérateur dans la liste préenregistrée du système",
      operatorSelect: "Opérateur : choisissez cette option si vous, en tant qu'opérateur, serez responsable de l'ajout des données des lieux de production. Vous aurez la possibilité de fournir une liste de producteurs, leurs exploitations et les géolocalisations dans l'application.",
      supplierSelect: "Fournisseur : choisissez cette option si le fournisseur sera responsable de l'ajout des données des lieux de production. Ils auront accès pour fournir la liste des producteurs, leurs exploitations et les géolocalisations directement dans l'application.",
      selectWhoWillAddPlaceData: "Sélectionnez qui ajoutera les données des lieux de production",
      supplierTooltip: "Sélectionnez le fournisseur dans la liste préenregistrée du système.",
      requiredAssessmentTooltip: "Choisir les informations d'évaluation nécessaires.",
      productionPlaceUsingLots: "Sélectionnez les lieux de production en utilisant des lots",
      dueDiligence: "Diligence raisonnable EUDR",
      internalRefNoTooltip: "Un identifiant unique attribué au sein d'une organisation ou d'un système pour référencer des données, des transactions ou des dossiers spécifiques à des fins de suivi et de gestion internes.",
      eudrRefNoTooltip: "Fait référence à un identifiant unique associé au Règlement de l'Union européenne sur la déforestation (EUDR), utilisé pour suivre et référencer les informations liées à la conformité dans le cadre des réglementations sur la déforestation.",
      companyIdTooltip: "Un identifiant distinct attribué à une entreprise ou une organisation à des fins d'identification et de suivi, souvent utilisé dans des systèmes, des bases de données ou des cadres réglementaires.",
      placeOfActivityTooltip: "Spécifiez le pays de l'opérateur où les activités sont menées et le pays où le produit entrera sur le marché de l'UE. Ces détails sont essentiels pour assurer une conformité précise aux exigences de l'EUDR."      ,
      productDetailToolTip: "Fournit des informations détaillées sur le produit, y compris son nom, sa masse nette, son volume, son nom scientifique et son nom commun.",
      productToolTip: "Nom du produit. Fait référence à un article tangible ou une marchandise produite, fabriquée ou commercialisée par une entreprise ou une organisation, souvent catégorisée en fonction de son type, de ses caractéristiques ou de son objectif.",
      productDescToolTip: "Fournit une explication textuelle ou un résumé des caractéristiques, des fonctionnalités ou des attributs d'un produit, visant à informer les utilisateurs ou les clients sur sa nature ou son fonctionnement.",
      subProductToolTip: "Nom du sous-produit. Désigne une catégorie spécifique ou un sous-ensemble d'une catégorie de produit plus grande, généralement utilisé pour une classification ou une différenciation supplémentaire dans une hiérarchie de produits.",
      netMassTooltTip: "Indique le poids d'un produit ou d'un article, généralement sans tenir compte du poids de l'emballage ou d'autres matériaux associés, souvent exprimé en unités de masse telles que les kilogrammes ou les livres.",
      volumeToolTip: "Fait référence à l'espace occupé par un produit ou une substance, généralement mesuré en unités cubiques telles que les mètres cubes ou les pieds cubes, utilisé pour quantifier la capacité ou la quantité dans un espace tridimensionnel.",
      scietificNameToolTip: "Nom taxonomique d'un organisme comprenant le genre et l'espèce, par ex. Coffea Arabica, Theobroma cacao L.",
      commonNameToolTip: "Un nom basé sur le langage normal de la vie quotidienne, par ex. Cacao, Café",
      assementBuilder: "Constructeur d'évaluation",
      assessment: "Évaluation",
      selectUsers: "Sélectionner les utilisateurs",
      assessmentsList: "Liste des évaluations",
      createAssessment: "Créer une évaluation",
      assessmentName: "Nom de l'évaluation",
      assessmentNameInfo: "Fonctionnalité pour trouver des évaluations ou des informations spécifiques.",
      searchAssessment: "Rechercher une évaluation",
      selectProcess: "Sélectionnez le processus d'évaluation",
      assessSettings: "Paramètres d'évaluation",
      assessmentTitle: "Titre de l'évaluation",
      assessmentTitleInfo: "Nom identifiant une évaluation.",
      assessDescription: "Description de l'évaluation",
      assessDescriptionInfo: "Brève explication de l'objectif ou du contenu de l'évaluation.",
      describeAsessment: "Décrire l'évaluation",
      country: "Pays",
      selectCountry: "Sélectionnez un pays",
      expiryTime: "Date d'expiration",
      expiryTimeInfo: "Durée jusqu'à ce que l'évaluation expire ou devienne invalide.",
      noQuestionEachStep: "Nombre de questions",
      byHeadings: "Par rubriques",
      assessmentStatus: "Statut de l'évaluation",
      multiStepAssess: "Évaluation en plusieurs étapes",
      allowAssessment: "Autoriser une évaluation à être répondue plus d'une fois",
      onlyIfExpired: "Uniquement si expiré",
      atAnyTime: "À tout moment",
      editAssessmentDetails: "Modifier les questions d'évaluation",
      assessmentDetail: "Détails de l'évaluation",
      addQuestion: "Ajouter une question d'évaluation",
      attachFiles: "Joindre des fichiers",
      digitalSignature: "Signature numérique",
      showChecklist: "Afficher la liste de contrôle",
      hideChecklist: "Masquer la liste de contrôle",
      fileType: "Type de fichier",
      allowMultipleFile: "Autoriser plusieurs pièces jointes",
      allowComment: "Autoriser les commentaires",
      uploadSignatureFile: "Télécharger le fichier de signature",
      drawSignature: "Dessiner une signature",
      uploadImage: "Télécharger une image",
      addSubHeading: "Ajouter un sous-titre",
      heading: "Titre",
      headingInfo: "Titre sous lequel la question d'évaluation sera catégorisée. Un menu déroulant pour sélectionner le titre.",
      subHeading: "Sous-titre",
      mutiStepHeadingLable: "Créer une nouvelle étape pour chaque sous-titre",
      dueDiligenceReports: "Rapports de diligence raisonnable",
      dueDiligenceReportsTT: "Une compilation des rapports de diligence raisonnable qui ont été émis, fournissant des informations sur l'état ou la condition actuelle de chaque rapport.",
      dueDiligenceReportsInfo: "Documentation détaillée résumant les conclusions et les résultats du processus de diligence raisonnable. Ces rapports fournissent des informations sur l'évaluation menée, y compris les risques identifiés, le statut de conformité et les recommandations pour l'atténuation ou l'amélioration.",
      logistics: "Logistique",
      editSubHeading: "Modifier le sous-titre",
      headingTitle: "Titre du titre",
      partOfOrigin: "Port d'origine",
      destination: "Port de destination",
      addStop: "Ajouter un arrêt",
      stop: "Arrêt",
      enterStop: "Entrer un arrêt",
      shipmentList: "Liste des expéditions",
      createShipment: "Créer une nouvelle expédition",
      manageFarms: "Gérer les exploitations",
      disputeResolution: "Résolution des litiges",
      disputeAssessment: "Évaluation des litiges",
      suppliers: "Fournisseurs",
      shipments: "Expéditions",
      dueDiligenceGuide: "Guide de diligence raisonnable",
      multiStepQuestion1: "Créer une nouvelle étape après",
      questions: "questions",
      questionsInfo: "Quantité de questions à chaque étape d'une évaluation en plusieurs étapes.",
      selectRequiredAssessment: "Sélectionnez les évaluations requises",
      filterAssessments: "Filtrer les évaluations",
      dueDiligenceReportCreation: "Création de rapport de diligence raisonnable",
      dueDiligenceNew: "Nouvelle diligence raisonnable",
      createNewReport: "Créer un nouveau rapport",
      operator: "Opérateur",
      supplier: "Fournisseur",
      supplierTT: "Sélection des fournisseurs ou fabricants impliqués dans la chaîne d'approvisionnement.",
      addMoreAssessments: "Ajouter plus d'évaluations",
      internalReferenceNumber: "Numéro de référence interne",
      internalReferenceNumberTT: "Un numéro de référence ou un code utilisé en interne pour organiser et gérer les rapports de diligence raisonnable.",
      fRinternalReferenceNumberTT: "Un numéro de référence interne est un identifiant unique attribué à un rapport de diligence raisonnable dans le système.",
      referenceNumber: "Numéro de référence",
      domestic: "National",
      import: "Importer",
      export: "Exporter",
      selectProduct: "Sélectionnez un produit",
      selectSubProduct: "Sélectionnez un sous-produit",
      addnewSupplier: "Ajouter un nouveau fournisseur",
      farmDeforestationReport: "Rapport de déforestation des exploitations",
      eudrRefNo: "Numéro de référence EUDR",
      eudrRefNoTT:"Un identifiant unique attribué à chaque rapport de diligence raisonnable, facilitant le suivi et la vérification de la conformité dans le cadre du règlement de l'Union européenne sur la déforestation (EUDR).",
      addProductionPlaceData: "Ajouter des Données de Lieu de Production",
    addProductionPlaceDataTooltip: "Choisissez comment vous souhaitez ajouter des données",
    addProductionPlaceDataDesc: 
        "Créez vos rapports en intégrant des données de production à partir de diverses sources. Sélectionnez une ou plusieurs sources pour compiler une liste complète de lieux de production pour vos rapports.",
    dimitraApps: "Applications Dimitra",
    addNew: "Ajouter Nouveau",
    existingData: "Données Existantes",
    manualDataEntry: "Saisie Manuelle des Données",
    importFile: "Importer un Fichier",
    connectedCoffee: "Café Connecté",
    connectedCacao: "Cacao Connecté",
    connectedFarmer: "Agriculteur Connecté",
    manaulProductionPlace: "Saisie Manuelle des Lieux de Production",
    farmerRegistrationId: "ID d'Enregistrement de l'Agriculteur",
      farmRegistrationId: "ID d'Enregistrement de la Ferme",
    manaulProductionPlaceTooltip: 
        "Processus d'entrée manuelle des lieux de fabrication dans le système.",
    addProductionPlace: "Ajouter un Lieu de Production",
    producerName: "Nom du Producteur",
    producerNameTT: 
        "Nom d'une personne/entreprise/organisation qui crée et fournit des biens ou services",
    producerCountry: "Pays du Producteur",
    producerCountryTT: "Le pays d'origine du producteur",
    totalArea: "Superficie Totale",
    number: "Nombre",
    productionPlaceDesc: "Description du Lieu de Production",
    area: "Superficie (ha)",
    type: "Type",
    actions: "Actes",
    selectType: "Sélectionner le Type",
    importProductionPlace: "Importer un Lieu de Production",
    importProductionPlaceTT: 
        "Permet aux utilisateurs d'importer des données de lieux de production en utilisant des options de téléchargement ou de téléversement de fichiers.",
    downloadXLSFormat: "TÉLÉCHARGER FORMAT XLS",
    downloadGeoJsonFormat: "Télécharger le Format GeoJSON",
    downloadXMLFormat: "Télécharger le Format XML",
    downloadFileFormatTemplates: "Télécharger les modèles de format de fichier",
    importantNote: "Note Importante",
    pleaseProvideFollowing: 
        "Veuillez fournir le format suivant (GeoJSON, XML ou ZIP)",
    existingProductionPlaces: "Lieux de Production Existants",
    existingProductionPlacesTT: 
        "Affiche une liste des lieux de production existants avec des détails tels que le nom du producteur, le pays, la superficie, le type et l'état de l'évaluation.",
    productionPlaceAndFarmID: "Lieu de Production & ID de Ferme",
    selectFileToUploadData: "Sélectionnez un fichier pour téléverser les données",
    filterByDate: "Filtrer par Date",
    dateOfRegister: "Date d'Enregistrement",
    dateOfLastReport: "Date du Dernier Rapport",
    clearAll: "Tout Effacer",
    addLocation: "Ajouter un Emplacement",
    pleaseCompleteBeforeProceedingToNext: 
        "Veuillez compléter la section des détails du rapport avant de passer à l'étape suivante.",
    progressSavedSuccessMsg: "Progrès sauvegardés avec succès !",
    failedSavedProgress: "Échec de la sauvegarde des progrès. Veuillez réessayer.",
    failedToCreateReportDetails: 
        "Échec de la création des détails du rapport. Veuillez réessayer.",
    unExpectedErrorMsg: "Une erreur inattendue s'est produite. Veuillez réessayer.",
    selectAssessment: "Sélectionner une Évaluation",
    confirmationPopup: "Popup de Confirmation",
    confirmation: "Confirmation",
    saveAndConfirmationMessage: "Êtes-vous sûr de vouloir enregistrer les modifications ?",
    confirmDownload: 
        "Voulez-vous télécharger tous les fichiers attachés au format PDF ?",
    supplierNotRegisterContent: 
        "Le fournisseur n'est pas enregistré. Souhaitez-vous envoyer une notification au fournisseur pour qu'il rejoigne la plateforme par e-mail ?",
    confirmationPopupMsg: 
        "Êtes-vous sûr de vouloir supprimer ce rapport ? Confirmer cette action entraînera une suppression définitive.",
    warningPopup: "Popup d'Avertissement",
    warningPopupMsg: 
        "Êtes-vous sûr de vouloir rejeter ce rapport ? Veuillez noter : Les données de ce rapport seront sauvegardées après rejet au cas où vous souhaiteriez les revoir plus tard.",
    automatedDeforestationProgressText: 
        "Vérification automatisée de la déforestation des données de géofence et identification des cas critiques",
    someRiskWereIdentifiedText: 
        "Des risques ont été identifiés dans les fermes suivantes, vous devriez examiner les fermes concernées et atténuer les risques avant de passer à l'étape suivante.",
    riskAssessmentAndMitigation: "Évaluation et Atténuation des Risques",
    riskAssessmentAndMitigationTT: 
        "Identification des risques potentiels et mise en œuvre de stratégies pour minimiser leur impact ou leur probabilité. Cela inclut l'évaluation des dangers, l'analyse de leurs conséquences potentielles et le développement de plans pour y faire face ou les atténuer efficacement.",
    riskAssessmentStatus: "Statut de l'Évaluation des Risques",
    riskAssessment: "Évaluation des Risques",
    uploadRiskAssessment: "Télécharger l'Évaluation des Risques",
    uploadRiskAssessmentTT: "Action pour téléverser un document d'évaluation des risques.",
    manualFillOutAssessment: "Remplir l'Évaluation Manuellement",
    manualFillOutAssessmentTT: 
        "Action pour remplir un formulaire d'évaluation manuellement.",
    criteria: "Critères (b, f et g)",
    downloadAssessmentForm: "Télécharger le Formulaire d'Évaluation",
    addSignature: "Ajouter une Signature",
    createNewDueDiligenceProgress: "Créer un Nouveau Processus de Diligence Raisonnée",
    usageLimits: "Limites d'Utilisation",
    usageLimitsTT: 
        "Réfère aux restrictions ou quotas prédéfinis sur le nombre de fois où ces rapports et évaluations peuvent être consultés, générés ou utilisés dans un délai donné. Ces limites sont établies pour gérer l'allocation des ressources, garantir une utilisation équitable et maintenir les performances du système.",
    totalReports: "Nombre Total de Rapports",
    eudrDeforestationAssessments: "Évaluations de Déforestation EUDR",
    totalAssessments: "Nombre Total d'Évaluations",
    listOfFarms: "Liste des Fermes",
    listOfFarmsTT: 
        "Affichage complet des fermes, incluant des informations telles que l'emplacement de production, le nom du producteur, le pays d'exploitation, la superficie en hectares, le type d'activités agricoles, les évaluations liées à la déforestation et les évaluations des risques potentiels associés aux opérations agricoles.",
    listOfFarmsInfo: 
        "Affichage complet des fermes, incluant des informations telles que l'emplacement de production, le nom du producteur, le pays d'exploitation, la superficie en hectares, le type d'activités agricoles, les évaluations liées à la déforestation et les évaluations des risques potentiels associés aux opérations agricoles.",
    perMonth: "Par Mois",
    share: "Partager",
    viewReport: "Voir le Rapport",
    viewReportSummary: "Voir le Résumé du Rapport",
    copy: "Copier",
    copyAndCreateNew: "Copier et Créer Nouveau",
    listOfSupplier: "Liste des Fournisseurs",
    addNewSupplier: "Ajouter de Nouveaux Fournisseurs",
    editSupplier: "Modifier le Fournisseur",
    supplierName: "Nom du Fournisseur",
    listOfOperators: "Liste des Opérateurs",
    addNewOperator: "Ajouter de Nouveaux Opérateurs",
    operatorName: "Nom de l'Opérateur",
    operators: "Opérateurs",
    editOperator: "Modifier l'Opérateur",
    eoriNumber: "Numéro EORI",
    isoCode: "Code ISO",
    enterEmailAddress: "Saisir l'adresse e-mail",
    enterFirstName: "Saisir le prénom",
    enterLastName: "Saisir le nom de famille",
    enterEORINumber: "Saisir le numéro EORI",
    myFarms: "Mes Fermes",
    listOfProducers: "Liste des Producteurs",
    producers: "Producteurs",
    addNewProducer: "Ajouter de Nouveaux Producteurs",
    lastAssessment: "Dernière Évaluation",
    noOfFarms: "Nombre de Fermes",
    shipmentID: "ID de l'Envoi",
    noOfReports: "Nombre de Rapports",
    
    operatorData: "Données de l'Opérateur",
    supplierData: "Données du Fournisseur",
    supplierDataTT: "Informations sur le fournisseur.",
    operatorDataTT: "Informations sur l'opérateur.",
    
    reportSummary: "Résumé des Risques",
    reportSummaryTT: "Aperçu du rapport.",
    totalNoOfGeofencePolygon: "Nombre Total de Polygones de Géofence",
    totalNoOfGeofencePolygonTT: "Nombre total de polygones de géofence.",
    totalNoOfGeofencePoint: "Nombre Total de Points de Géofence",
    totalNoOfGeofencePointTT: "Nombre total de points de géofence.",
    totalNoOfFarms: "Nombre Total de Fermes",
    totalNoOfFarmsTT: "Nombre total de fermes.",
    totalAreaFinalReport: "Surface Totale (ha)",
    totalNoOfDeforestation: "Nombre Total de Déforestations",
    totalNoOfDeforestationTT: "Nombre total d'évaluations de déforestation.",
    totalNoOfHighDeforestation: "Nombre Total de Déforestations Élevées",
    totalNoOfHighDeforestationTT: "Nombre total de fermes à déforestation élevée.",
    totalNoOfRiskAssessments: "Nombre Total d'Évaluations des Risques",
    totalNoOfRiskAssessmentsTT: "Nombre total d'évaluations des risques.",
    
    productDetail: "Détails du Produit",
    productDetailTT: "Informations sur le produit.",
    
    product: "Produit",
    productTT: "Nom du produit. Fait référence à un article tangible produit, fabriqué ou commercialisé par une entreprise, souvent classé selon son type, ses caractéristiques ou son objectif.",
    productDescription: "Description du Produit",
    productDescriptionTT: "Fournit une explication ou un résumé des caractéristiques, des fonctionnalités ou des attributs d'un produit.",
    netMass: "Masse Nette",
    netMassTT: "Indique le poids d'un produit, généralement sans inclure l'emballage.",
    volume: "Volume",
    volumeTT: "Désigne l'espace occupé par un produit, mesuré en unités cubiques.",
    scientificName: "Nom Scientifique",
    scientificNameTT: "Nom taxonomique d'un organisme e.g Coffea Arabica, Theobroma cacao L.",
    commonName: "Nom Commun",
    commonNameTT: "Nom basé sur la langue courante e.g. Cacao, Café",
    
    productionPlaces: "Lieux de Production",
    productionPlacesTT: "Affiche une liste des lieux de production existants avec des détails.",
    
    selectProductionPlacesUsingLots: "Sélectionner les Lieux de Production à l'Aide des Lots",
    SelectProductionPlacesUsingFarms: "Sélectionner les Lieux de Production à l'Aide des Fermes",
    
    areaForPointGeofence: "Zone pour Géofence Point",
    accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "Selon l'EUDR, les fermes de moins de 4 hectares n'ont pas besoin d'un polygone.",
    circularAreaEquivalent: "Nous utiliserons une zone circulaire équivalente à la taille de la ferme pour vérifier la déforestation.",
    ifTheFarmsAreSmallerPleaseEnterTheStandardSizeInTheFieldBelow: "Si les fermes sont plus petites, saisissez la taille standard dans le champ ci-dessous.",
    defaultCircularGeofence: "Les fermes sans géofence recevront une valeur par défaut de 4 hectares.",
    defaultAreaValueSpecified: "Les fermes sans géofence recevront une zone par défaut spécifiée.",
    uploadFileBeingProcessed: "Vos fichiers téléchargés sont en cours de traitement. Vous serez redirigé vers la liste des rapports.",
    processingLocations: "Traitement des Lieux",
    
    lotId: "ID du Lot",
    qualityGade: "Qualité",
    
    onlyShowFarmsWithIssues: "Afficher uniquement les fermes avec des problèmes",
    
    analyzingStatus: "Analyse du Statut de Déforestation",
    analyzingDesc: "Vos fermes subissent une analyse automatique de la déforestation.",
    readyToProceed: "Prêt à Procéder",
    mitigationRequired: "Atténuation Nécessaire",
    viewSummary: "Voir le Résumé",
    viewAssessment: "Voir l'Évaluation",
    disputes: "Litiges",
    manualRiskMitigation: "Atténuation des Risques Manuelle",
    veryHighProbability: "Très Haute Probabilité",
    highProbability: "Haute Probabilité",
    mediumProbability: "Probabilité Moyenne",
    lowProbability: "Faible Probabilité",
    veryLowProbability: "Très Faible Probabilité",
    zeroProbability: "Probabilité Nulle/Négligeable",
    manualMitigated: "Atténué Manuellement",
    disputeDesc: "Cliquez sur une des demandes de litige ci-dessous pour plus de détails.",
    geofenceColorCode: "Code Couleur Géofence:",
    noDisputeHaveSubmitted: "Aucun litige soumis pour le moment.",
    disputeDetails: "Détails du Litige",
    chooseDisputeReason: "Choisir la Raison du Litige",
    pleaseAttachDoc: "Veuillez joindre des documents pour soutenir votre réponse.",
    additionalNotes: "Notes Supplémentaires",
    aggrementStatement: "Je comprends que la terre affectée ne sera pas utilisée à des fins agricoles dans les années à venir.",
    addGeofenceRadius: "Ajouter le Rayon du Géofence",
    totalGeofenceRadius: "Le Rayon Total du Géofence est",
    resolutionHistory: "Historique des Résolutions",
    proceed: "Procéder",
    wildFire: "Feu de Forêt",
    controlledFire: "Feu Contrôlé",
    clearingForAgriculture: "Défrichement pour l'Agriculture",
    pestAndDiseases: "Parasites et Maladies",
    naturalChangesInCanopy: "Changements Naturels du Couvert",
    strongWinds: "Vents Violents",
    otherNaturalDisasters: "Autres Catastrophes Naturelles",
    flooding: "Inondation",
    logging: "Exploitation Forestière",
    infrastructure: "Infrastructure",
    urbanization: "Urbanisation",
    landGrabbingOrPopulationPressure: "Accaparement de Terres ou Pression Démographique",
    mining: "Exploitation Minière",
    plantationForestBeforeDeadline: "Forêt Plantée avant la Date Limite",
    convertedToPlantationForest: "Converti en Forêt Plantée",
    cultivatedAreaBeforeDeadline: "Zone Cultivée avant la Date Limite",
    forestStillPreserved: "La Forêt est Toujours Préservée",
    downloadAsPDF: "Télécharger en PDF",
    downloadAsJSON: "Télécharger en JSON",
    downloadOptions: "Options de Téléchargement",
    productionPlacesHighDeforestationProbability: "Lieux de production avec une probabilité élevée de déforestation",
    geofenceHighDeforestationProbability: "Géofence avec une probabilité élevée de déforestation",
    EUDRReferenceNumber: "Numéro de Référence EUDR",
    totalNoOfRiskAssessment: "Nombre Total d'Évaluations des Risques",
    totalNoOFDeforestationAssessments: "Nombre Total d'Évaluations de la Déforestation",
    totalNoOfGeofencePoints: "Nombre Total de Points de Géofence",
    totalNoOfGeofencePolygons: "Nombre Total de Polygones de Géofence",
    dueDiligenceReportStatus: "Statut du Rapport de Diligence Raisonnable",
    declarationStatement: "Déclaration par l'Opérateur",
    undoDelete: "Annuler la Suppression",
    analyzingDeforestation: "Analyse de la Déforestation",
    processingFarm: "Traitement de la Ferme",
    operatorDecleration: "Déclaration par l'Opérateur",
    operatorDeclerationTT: "Déclaration légale ou confirmation par un opérateur.",
    supplierDecleration: "Déclaration par le fournisseur",
    supplierDeclerationTT: "Déclaration de conformité par le fournisseur.",
    pleaseSelectAtLeastOneItem: "Veuillez sélectionner au moins un élément.",
    pleaseSelectAtLeastOneSource: "Veuillez sélectionner au moins une source.",
    invalidFileFormatPleaseUploadValidFile: "Format de fichier invalide. Veuillez télécharger un fichier .xml, .kml ou .geojson valide.",
    pleaseUploadAValidFile: "Veuillez télécharger un fichier valide.",
    fileUploadedDuccessfully: "Fichier téléchargé avec succès !",
    anErrorOccured: "Une erreur s'est produite.",
    successfullyUpdatedDefaultFarmArea: "Zone agricole par défaut mise à jour avec succès.",
    pleaseAddProductionPlacesData: "Veuillez ajouter des données sur les lieux de production.",
    failedToFetchSettings: "Impossible de récupérer les paramètres. Veuillez vérifier vos paramètres ou contacter le support si le problème persiste.",
    updatedDueDiligenceReport: "Rapport de diligence raisonnable mis à jour",
    updatedDueDiligenceStatus: "Le statut de diligence raisonnable a été mis à jour avec succès.",
    failedToWriteDeforestationDataToBlockchain: "Échec de l'écriture des données de déforestation sur la blockchain, veuillez réessayer.",
    countryIsRequired: "Le pays est requis",
    loadingPleaseWait: "Chargement... Veuillez patienter",
    successfullyGeneratedEUDRDeforestationStatus: "Statut de déforestation EUDR généré avec succès.",
    successfullyUploadedToTheBlockchain: "Succès ! Le rapport de diligence EUDR a été téléchargé avec succès sur la blockchain.",
    compilanceRiskWarning: "Avertissement de risque de conformité",
    issueIdentifiedOnFarms: "Des problèmes ont été identifiés sur certaines exploitations nécessitant une attention avant de passer à l'étape suivante. Vous pouvez choisir de résoudre ces problèmes maintenant ou continuer à l'étape suivante et les résoudre plus tard.",
    blockchainDescs: [
        "Téléchargement du rapport sur la blockchain, veuillez patienter...",
        "Votre rapport de diligence raisonnable est en cours de téléchargement sur la blockchain. Vous serez redirigé vers la page de liste des rapports de diligence raisonnable pour consulter le statut."
    ],
    reportDownloadedSuccessfully: "Rapport téléchargé avec succès !",
    deleteProductionPlaceData: "Supprimer les données du lieu de production",
    areYouSureYouWantToContinueThisAction: "Êtes-vous sûr de vouloir continuer cette action ?",
    noAssessment: "Aucune évaluation trouvée",
    uploadingToBlockchain: "Téléchargement du rapport sur la blockchain, veuillez patienter...",
    beingUploadToBlockChain: "Votre rapport de diligence raisonnable est en cours de téléchargement sur la blockchain. Vous serez redirigé vers la page de liste des rapports pour consulter le statut.",
    uploading: "Téléchargement",
    attachFile: "Joindre un fichier",
    close: "Fermer",
    status: "Statut",
    lotID: "ID du lot",
    noOfFarm: "Nombre d'exploitations",
    processingDate: "Date de traitement",
    origin: "Origine",
    selectUsingLots: "Sélectionnez les lieux de production à l'aide des lots",
    productionPlaceUsingFarms: "Sélectionnez les lieux de production à l'aide des exploitations",
    searchFarmName: "Rechercher le nom de l'exploitation",
    viewLocation: "Voir la géolocalisation",
    netMassKG: "Masse nette (kg)",
    volumeM3: "Volume (m3)",
    areaInHA: "Superficie (ha)",
    eudrUploadedToBlockChain: "Succès ! Le rapport de diligence EUDR a été téléchargé avec succès sur la blockchain.",
    viewDeforestationAssessment: "Voir l'évaluation de la déforestation",
    viewDeforestationCertificate: "Voir le certificat de déforestation",
    selectCountries: "Sélectionner des pays",
    writingToBlockchain: "Écriture sur la blockchain",
    cattle: "Bétail",
    cocoa: "Cacao",
    coffee: "Café",
    wood: "Bois",
    soya: "Soja",
    rubber: "Caoutchouc",
    oilPlam: "Palmier à huile",
    subProduct1: "0102 21, 0102 29 Bétail vivant",
  subProduct2: "0201 Viande de bétail, fraîche ou réfrigérée",
  subProduct3: "0202 Viande de bétail, congelée",
  subProduct4: "0206 10 Offal comestible de bétail, frais ou réfrigéré",
  subProduct5: "0206 22 Foies de bétail comestibles, congelés",
  subProduct6: "0206 29 Autres abats comestibles de bétail (sauf langues et foies), congelés",
  subProduct7: "1602 50 Autres viandes, abats, sang préparés ou conservés, de bétail",
  subProduct8: "4101 Peaux et cuirs bruts de bétail (frais, salés, séchés, limés, marinés ou autrement conservés, mais non tannés, habillés en parchemin ou préparés davantage), qu’ils soient ou non écorchés ou fendus",
  subProduct9: "4104 Peaux tannées ou en croûte de bétail, sans poils, qu’elles soient fendues ou non, mais non préparées davantage",
  subProduct10: "4107 Cuirs de bétail, préparés après le tannage ou le croûtage, y compris les cuirs habillés en parchemin, sans poils, qu’ils soient ou non fendus, autres que ceux du poste 4114",
  subProduct11: "1801 Fèves de cacao, entières ou brisées, crues ou torréfiées",
  subProduct12: "1802 Coques de cacao, écorces, peaux et autres déchets de cacao",
  subProduct13: "1803 Pâte de cacao, qu'elle soit ou non dégraissée",
  subProduct14: "1804 Beurre de cacao, graisse et huile",
  subProduct15: "1805 Poudre de cacao, ne contenant pas de sucre ajouté ou d’autres matières sucrantes",
  subProduct16: "1806 Chocolat et autres préparations alimentaires contenant du cacao",
  subProduct17: "0901 Café, qu'il soit torréfié ou décaféiné ; coques et peaux de café ; substituts de café contenant du café en toute proportion",
  subProduct18: "1207 10 Noix et graines de palmier",
  subProduct19: "1511 Huile de palme et ses fractions, qu'elles soient ou non raffinées, mais non chimiquement modifiées",
  subProduct20: "1513 21 Huile de palmiste et de babassu brute et ses fractions, qu'elles soient ou non raffinées, mais non chimiquement modifiées",
  subProduct21: "1513 29 Huile de palmiste et de babassu et leurs fractions, qu'elles soient ou non raffinées, mais non chimiquement modifiées (à l'exclusion de l'huile brute)",
  subProduct22: "2306 60 Tourteaux et autres résidus solides de noix ou graines de palmier, qu'ils soient ou non broyés ou sous forme de granulés, résultant de l'extraction des graisses ou huiles de palmier",
  subProduct23: "2905 45 Glycérol, avec une pureté de 95 % ou plus (calculée sur le poids du produit sec)",
  subProduct24: "2915 70 Acide palmitique, acide stéarique, leurs sels et esters",
  subProduct25: "2915 90 Acides monocarboxyliques acycliques saturés, leurs anhydrides, halogénures, peroxydes et peroxysels, leurs dérivés halogénés, sulphonés, nitrés ou nitrosés (à l'exclusion de l'acide formique, de l'acide acétique, des acides mono-, di- ou trichloroacétiques, de l'acide propionique, des acides butanoïques, des acides pentanoïques, de l'acide palmitique, de l'acide stéarique, de leurs sels et esters, et de l'anhydride acétique)",
  subProduct26: "3823 11 Acide stéarique, industriel",
  subProduct27: "3823 12 Acide oléique, industriel",
  subProduct28: "3823 19 Acides monocarboxyliques industriels ; huiles acides provenant du raffinage (à l'exclusion de l'acide stéarique, de l'acide oléique et des acides gras de colophane)",
  subProduct29: "3823 70 Alcool gras industriel",
  subProduct30: "4001 Caoutchouc naturel, balata, gutta-percha, guayule, chicle et gommes naturelles similaires, sous formes primaires ou en plaques, feuilles ou bandes",
  subProduct31: "4005 Caoutchouc composé, non vulcanisé, sous formes primaires ou en plaques, feuilles ou bandes",
  subProduct32: "4006 Caoutchouc non vulcanisé sous d'autres formes (par exemple, tiges, tubes et profils) et articles (par exemple, disques et anneaux)",
  subProduct33: "4007 Fil de caoutchouc vulcanisé et cordes",
  subProduct34: "4008 Plaques, feuilles, bandes, tiges et formes profilées en caoutchouc vulcanisé autres que le caoutchouc dur",
  subProduct35: "4010 Courroies ou bandes transporteuses en caoutchouc vulcanisé",
  subProduct36: "4011 Pneumatiques neufs en caoutchouc",
  subProduct37: "4012 Pneumatiques retreadés ou usagés en caoutchouc ; pneus solides ou à coussin ; bandes de pneus et flasques de pneus en caoutchouc",
  subProduct38: "4013 Chambres à air, en caoutchouc",
  subProduct39: "4015 Articles d'habillement et accessoires de vêtement (y compris gants, moufles et mitaines), à des fins diverses, en caoutchouc vulcanisé autre que le caoutchouc dur",
  subProduct40: "4016 Autres articles en caoutchouc vulcanisé autre que le caoutchouc dur, non spécifiés ailleurs au chapitre 40",
  subProduct41: "4017 Caoutchouc dur (par exemple, ébonite) sous toutes ses formes, y compris les déchets et débris ; articles en caoutchouc dur",
  subProduct42: "1201 Graines de soja, qu'elles soient ou non brisées",
  subProduct43: "1208 10 Farine et tourteau de soja",
  subProduct44: "1507 Huile de soja et ses fractions, qu'elles soient ou non raffinées, mais non chimiquement modifiées",
  subProduct45: "2304 Tourteaux et autres résidus solides, qu'ils soient ou non broyés ou sous forme de granulés, résultant de l'extraction de l'huile de soja",
  subProduct46: "4401 Bois de combustible, en billes, en morceaux, en brindilles, en fagots ou sous des formes similaires ; bois en copeaux ou en particules ; sciure et déchets de bois et débris, qu'ils soient ou non agglomérés en billes, briquettes, granulés ou formes similaires",
  subProduct47: "4402 Charbon de bois (y compris charbon de coquille ou de noyau), qu'il soit ou non aggloméré",
  subProduct48: "4403 Bois brut, qu'il soit écorcé ou non, ou grossièrement équarri",
  subProduct49: "4404 Bois pour cercles ; poteaux fendus ; pieux, piquets et stakes en bois, pointus mais non sciés longitudinalement ; bâtons en bois, grossièrement taillés mais non tournés, cintrés ou travaillés autrement, appropriés pour la fabrication de cannes, parapluies, poignées d'outils ou articles similaires ; bois à puces et articles similaires",
  subProduct50: "4405 La laine de bois ; farine de bois",
  subProduct51: "4406 Traverses de chemin de fer ou de tramway (liens) en bois",
  subProduct52: "4407 Bois scié ou fendu longitudinalement, tranché ou pelé, qu'il soit ou non raboté, poncé ou assemblé",
  subProduct53: "4408 Feuilles pour placage (y compris celles obtenues par tranchage de bois lamellé), pour contreplaqué ou pour d'autres bois laminés similaires et autres bois sciés longitudinalement, tranchés ou pelés, qu'ils soient ou non rabotés, poncés, assemblés ou reliés à l'extrémité",
  subProduct54: "4409 Bois (y compris bandes et frises pour revêtement de parquet, non assemblées) façonné en continu (rainuré, cannelé, en rebord, chanfreiné, jointé en V, mouluré, arrondi ou similaire) sur ses bords, extrémités ou faces, qu'il soit ou non raboté, poncé ou assemblé",
  subProduct55: "4410 Panneaux de particules, panneaux de copeaux orientés (OSB) et panneaux similaires (par exemple, panneaux de wafer) en bois ou autres matériaux ligneux, qu'ils soient ou non agglomérés avec des résines ou d'autres substances organiques",
  subProduct56: "4411 Panneaux de fibres de bois ou autres matériaux ligneux, qu'ils soient ou non liés avec des résines ou d'autres substances organiques",
  subProduct57: "4412 Contreplaqué, panneaux en placage et bois lamellé similaires",
  subProduct58: "4413 Bois densifié, en blocs, plaques, bandes ou formes profilées",
  subProduct59: "4414 Cadres en bois pour peintures, photographies, miroirs ou objets similaires",
  subProduct60: "4415 Caisses, boîtes, caisses, tambours et emballages similaires en bois ; tambours de câble en bois ; palettes, palettes à caisses et autres planches de charge en bois",
  subProduct61: "Colliers de palettes en bois (non incluant les matériaux d'emballage utilisés exclusivement comme support, protection ou transport d'un autre produit placé sur le marché)",
  subProduct62: "4416 Fûts, barils, cuves, tonneaux et autres produits de tonnellerie et pièces de ceux-ci, en bois, y compris les douelles",
  subProduct63: "4417 Outils, corps d'outils, poignées d'outils, corps de balais ou de pinceaux, en bois ; formes de chaussures en bois",
  subProduct64: "4418 Menuiserie et menuiserie en bois, y compris panneaux en bois cellulaire, panneaux de sol assemblés, bardeaux et bardeaux",
  subProduct65: "4419 Articles de table et de cuisine, en bois",
  subProduct66: "Marqueterie et bois incrusté ; boîtes et étuis pour bijoux ou couverts, et articles similaires, en bois ; statuettes et autres ornements, en bois ; articles en bois de mobilier ne relevant pas du Chapitre 94",
  subProduct67: "4421 Autres articles en bois",
  subProduct68: "Pâte et papier des chapitres 47 et 48 de la Nomenclature combinée, à l'exception des produits à base de bambou et récupérés (déchets et ferrailles)",
  subProduct69: "49 Livres imprimés, journaux, images et autres produits de l'industrie de l'impression, manuscrits, dactylogrammes et plans, en papier",
  subProduct70: "9401 Sièges (autres que ceux du poste 9402), qu'ils soient ou non convertibles en lits, et leurs parties, en bois",
  subProduct71: "9403 30, 9403 40, 9403 50, 9403 60 et 9403 91 Meubles en bois, et leurs parties",
  subProduct72: "9406 10 Bâtiments préfabriqués en bois",
  
  selectStatus: "Sélectionner le statut",
  riskAssessmentNotApproved: "Les lieux de production ne sont pas approuvés.",
  
  blockchainVerification: "Vérification de la Blockchain",
  scanQrBlockchain: "Scannez ce code QR pour voir le rapport de diligence raisonnable EUDR sur la blockchain.",
  downloadQrCode: "Télécharger le code QR",
  eudrPublicReport: "Rapport public de diligence raisonnable Dimitra EUDR",
  scanQrEudr: "Scannez ce code QR pour voir le rapport de diligence raisonnable EUDR sur le site web public.",
  viewReportForPublic: "Cliquez ici pour voir le rapport public",
  viewReportOnBlockChain:"Cliquez ici pour voir le rapport sur la blockchain",
  declarationMissing: "Déclaration manquante",

  removeRiskFarms: "RETIRER LES FERME RISQUE",
  disregardRiskDocument: "IGNOREZ LES FERME RISQUE",
  attachRiskMitigationDocumentForNonCompliantFarms: "ATTACHER UN DOCUMENT DE MITIGATION DES RISQUES POUR TOUTES LES FERME NON-CONFORMES",
  uploadMitigationDocumentForNonCompliantFarms: "Téléverser un document de mitigation des risques pour toutes les fermes non conformes changera le statut des fermes ayant « Mitigation requise » à « Mitigé manuellement ».",
  disregardFarmWithIssuesTitle:"Ignorer les fermes avec des problèmes",
  disregardFarmWithIssuesMessage: "En sélectionnant 'Ignorer', le statut de l'évaluation des risques des fermes manquantes ne sera pas pris en compte dans ce rapport. Les fermes resteront dans le rapport, mais leurs évaluations en attente n'affecteront pas le statut de conformité. Veuillez confirmer que vous souhaitez continuer.",
  removeRiskFarmTitle: "Retirer les fermes",
  removeRiskFarmMessage: "En sélectionnant 'Retirer', les fermes dont le statut d'évaluation des risques est 'Mitigation requise' ou 'Rejeté' seront supprimées de ce rapport. Veuillez confirmer que vous souhaitez continuer.", 
  fileName: "Nom du fichier",
  dateAndTime: "Date et heure",
  downloadProgressStatus: "État d'avancement du téléchargement",
  downloadHistory: "Historique des téléchargements",
  downloaded: "Téléchargé",
  inprogress: "En cours",
  failed: "Échoué",
  showAllDownloads: "Afficher tous les téléchargements",
  inProgress: "En cours",
  downloadCompleted: "Téléchargement terminé",
  downloadFailed: "Téléchargement échoué",
  errorDeletingItem: "Impossible de supprimer l'élément. Veuillez réessayer plus tard.",
  anErrorOccuredPlsTryAgain: "Une erreur est survenue. Veuillez réessayer.",
  invalidData: "Les données fournies sont invalides. Veuillez vérifier et réessayer.",
  fileIsReady: "Le fichier est prêt à être utilisé",
  invalidFilePathOrUrl: "Le chemin ou l'URL du fichier est invalide.",
  errorDownloadingFile: "Un problème est survenu lors du téléchargement du fichier. Veuillez réessayer.",
  downloadInitiated: "Téléchargement démarré",
  beingDownloaded: " est en cours de téléchargement. Temps estimé",


  multiStepSurveyDetails: "En fonction du nombre de questions dans une étape, toutes les questions du sondage seront regroupées et affichées par étapes. Cependant, cette configuration n'est disponible qu'avant d'ajouter des questions ou des sous-titres. Une fois qu'une question ou un sous-titre est ajouté, la configuration multi-étapes sera automatiquement désactivée. Veuillez supprimer toute question ou sous-titre pour réactiver cette option.",
  estimatedTime: "Temps estimé",
  tryAgain: "Essayer à nouveau"
},

diligenceGuide: {
  guide: "Guide",
  downloadPdfManual: "Télécharger le manuel PDF",
  watchDemoVideo: "Regarder la vidéo de démonstration",
  viewManualOnWeb: "Voir le manuel sur le web",
},

welcomeScreenDiligenceGuide: {
  title: "Votre guide essentiel",
  description: `Explorez notre page des guides d'aide du système de diligence raisonnable EUDR pour des ressources essentielles, y compris des manuels PDF, des tutoriels vidéo et de l'assistance en ligne. Donnez-vous les moyens de naviguer efficacement sur la plateforme et d'optimiser votre flux de travail.`,
  continueToTheDueDiligenceSystem: "Continuer vers le système de diligence raisonnable",
},

containerTypes: {
  standardDry: "Conteneur sec standard (20ft, 40ft)",
  highCube: "Conteneur High Cube",
  openTop: "Conteneur à toit ouvert",
  flatRack: "Conteneur à rack plat",
  refrigerated: "Conteneur réfrigéré (Reefer)",
  tank: "Conteneur-citerne",
  ventilated: "Conteneur ventilé",
  insulated: "Conteneur isolé",
  platform: "Conteneur plateforme",
  halfHeight: "Conteneur demi-hauteur",
  bulk: "Conteneur en vrac"
},

assessmentStatus: {
  riskAssesmentSummary: "Résumé de l'évaluation des risques",
  riskAssesmentSummaryTT: "Résumé de l'évaluation des risques",
  totalNoOfFarms: "Nombre total de fermes",
  assessmentsCompleted: "Évaluations terminées",
  assessmentsPending: "Évaluations en attente",
  requiredMitigation: "Mitigation requise"
}
}